export const AUTH_LINKED_PATH = "/auth/linked";

const EMBED_UID_KEY = "obat_embed_uid";

function isIframeForcedByEnv() {
  const value = import.meta.env.VITE_FORCE_IFRAME;
  return value === "true" || value === "1";
}

export function isInIframe() {
  if (isIframeForcedByEnv()) {
    return true;
  }

  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function isAuthLinkedPath(pathname) {
  return pathname === AUTH_LINKED_PATH;
}

export function getRedirectFromSearch(search) {
  const redirect = new URLSearchParams(search || "").get("redirect");
  if (!redirect || !redirect.startsWith("/")) {
    return "/dashboard";
  }
  return redirect;
}

export function buildAuthLinkedUrl(location) {
  const params = new URLSearchParams();
  const currentPath = `${location.pathname}${location.search}`;

  if (!isAuthLinkedPath(location.pathname)) {
    params.set("redirect", currentPath);
  }

  const query = params.toString();
  return query ? `${AUTH_LINKED_PATH}?${query}` : AUTH_LINKED_PATH;
}

export function getEmbedUid(search) {
  const params = new URLSearchParams(search || "");
  const fromUrl = params.get("embed_uid");

  if (fromUrl) {
    try {
      sessionStorage.setItem(EMBED_UID_KEY, fromUrl);
    } catch {
      // ignore
    }
    return fromUrl;
  }

  try {
    return sessionStorage.getItem(EMBED_UID_KEY);
  } catch {
    return null;
  }
}

export function setEmbedUid(uid) {
  if (!uid) return;
  try {
    sessionStorage.setItem(EMBED_UID_KEY, uid);
  } catch {
    // ignore
  }
}

export function getTokenFromSearch(search) {
  return new URLSearchParams(search || "").get("token");
}
